var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("개인정보취급방침 준비중입니다.")])}
var staticRenderFns = []

export { render, staticRenderFns }